module.exports = __webpack_public_path__ + "static/media/fleet-manage.70c6882e.jpg";